import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { HttpService } from '../../../shared-services/http.service';
import { SearchChargeSummaryRequestDto, SearchChargeSummaryResponseDto } from '../../models/charge-summary.models';


@Injectable({ providedIn: 'root' })
export class ChargeSummaryService {
  constructor(
    private apiServiceRequest: HttpService,
    private _http: HttpClient) {
  }


  async SearchChargeSummary(item: SearchChargeSummaryRequestDto | undefined) {
    const baseurl = '/api/ChargeSummary/SearchChargeSummary';
    return await this.apiServiceRequest.SendLocal(baseurl, item).toPromise();
  }
  async DownloadChargeSummary(item: SearchChargeSummaryRequestDto | undefined) {
    const baseurl = '/api/ChargeSummary/DownloadChargeSummary';
    return await this.apiServiceRequest.SendLocal(baseurl, item).toPromise();
  }
  async GetChargeStationByLoggedInCpoId() {
    const baseurl = '/api/ChargeStation/GetChargeStationByLoggedInCpoId';
    return await this.apiServiceRequest.getAllLocal(baseurl).toPromise();
  }

  async GetChargeUnites(chargeStationId : any) {
    const baseurl = '/api/ChargeSummary/GetChargeUnites?chargeStationId=' + chargeStationId;
    return await this.apiServiceRequest.getAllLocal(baseurl).toPromise();

  }
  async GetChargeSummaryStats() {
    const baseurl = '/api/ChargeSummary/GetChargeHistoryStats';
    return await this.apiServiceRequest.getAllLocal(baseurl).toPromise();

  }
}




